import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { LOCALE_ID, NgModule } from '@angular/core';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { AuthGuard } from './shared/util/auth.guard';

import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { RoutesModule } from './routes/routes.module';
import '@progress/kendo-angular-intl/locales/vi/all';
import { registerLocaleData } from '@angular/common';
import localeVi from '@angular/common/locales/vi';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';
//import { SignalRModule } from 'ng2-signalr';
//import { SignalRConfiguration } from 'ng2-signalr';

//import { AngularSplitModule } from 'angular-split';
import {Global} from './shared/global';


//import { Ng2Bs3ModalModule } from 'ng2-bs3-modal';
//import { ReactiveFormsModule } from '@angular/forms';

// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

registerLocaleData(localeVi);

// >= v2.0.0
//export function createConfig(): SignalRConfiguration {
//  const c = new SignalRConfiguration();
//  c.hubName = 'ServiceSign';
//  //c.qs = { user: 'donald' };
//  c.url = 'http://localhost:3868';
//  c.logging = true;

//  // >= v5.0.0
//  c.executeEventsInZone = true; // optional, default is true
//  c.executeErrorsInZone = false; // optional, default is false
//  c.executeStatusChangeInZone = true; // optional, default is true
//  return c;
//}

//  "https://stackblitz.com/edit/angular-ng2-signalr?file=src%2Fapp%2Fapp.module.ts,src%2Fapp%2Fhello.component.ts"


@NgModule({
    declarations: [
        AppComponent
    ],
    
    imports: [
        HttpClientModule,
      //MatTableModule,
        BrowserAnimationsModule, // required for ng2-tag-input
        CoreModule,
        SlimLoadingBarModule.forRoot(),
      //AngularSplitModule.forRoot(),
       
        SharedModule.forRoot(),
        RoutesModule,
        LayoutModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
      })
      //, SignalRModule.forRoot(createConfig) 

    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'vi' },
        AuthGuard
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
